<template>
    <modal v-model="showModal">
        <section class="student-picker-view">
            <h3>
                <slot name="title"/>
            </h3>
            <app-alert type="info">Type the name or email of the student below.</app-alert>
            <label>
                <span class="visuallyhidden">Name or Email</span>
                <app-input 
                    v-model="query" 
                    placeholder="Name or Email"
                    autofocus
                    autocomplete="nope"/>
            </label>
            <div class="students">
                <student-table
                    :items="students"
                    :columns="['first_name','last_name','email']"
                    :allow-sort="false"
                    :handle-click="handleSelect"/>
            </div>
        </section>
    </modal>
</template>
<script>
import StudentTable from '../Student/StudentTable'
import Student from '@/store/models/Student'

export default {
    name: 'student-picker',
    components: {
        StudentTable
    },
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {
            students: [],
            query: '',
            showModal: false
        }
    },
    mounted() {
        this.showModal = this.value
    },
    methods: {
        getStudentList(query) {
            this.loading = true
            Student.$search({
                query,
                per_page: 5
            }).then(students => {
                this.loading = false
                this.students = students
            })
        },
        handleSelect(student) {
            this.showModal = false
            this.query = ''
            this.students = []
            this.$emit('selected-student', student)
            return false
        }
    },
    watch: {
        query(newValue) {
            this.getStudentList(newValue)
        },
        value(newValue) {
            this.showModal = newValue
        },
        showModal(newValue) {
            this.$emit('input', newValue)
        }
    }
}
</script>

<style lang="stylus"></style>
